import * as API from '../api/training-program-settings.api';
import * as VM from '../model/training-program-settings.vm';

const TASK_TYPE_MAP: Record<string, API.TaskType> = {
    PATIENT_TEST: API.TaskType.PATIENT_TEST,
    OBSERVED_PATIENT_TEST: API.TaskType.OBSERVED_PATIENT_TEST,
    E_LEARNING: API.TaskType.E_LEARNING,
    QUALITY_CONTROL: API.TaskType.QUALITY_CONTROL,
    CUSTOM_MANUAL_TASK: API.TaskType.CUSTOM_MANUAL_TASK,
};

export const mapTrainingProgramConfigFromApiToVm = (
    trainingProgramsConfig: API.TrainingProgramsConfig
): VM.TrainingProgramsConfig => ({
    id: trainingProgramsConfig.id,
    maxTrainings: trainingProgramsConfig.maxTrainings ?? undefined,
    applicableLocationsConfig: mapApplicableLocationsConfigFromApiToVm(
        trainingProgramsConfig.applicableLocationsConfig
    ),
    trainerAppConfig: mapTrainerAppConfigFromApiToVm(trainingProgramsConfig.trainerAppConfig),
});

export const mapApplicableLocationsConfigFromApiToVm = (
    applicableLocationsConfig: API.ApplicableLocationsConfig
): VM.ApplicableLocationsConfig => ({
    enableApplicableLocations: applicableLocationsConfig.enableApplicableLocations,
});

export const mapTrainerAppConfigFromApiToVm = (trainerAppConfig: API.TrainerAppConfig): VM.TrainerAppConfig => ({
    allowActions: trainerAppConfig?.allowActions,
    enableTrainerSignature: trainerAppConfig?.enableTrainerSignature,
    enableOperatorSignature: trainerAppConfig?.enableOperatorSignature,
    enableUploadEvidence: trainerAppConfig?.enableUploadEvidence,
    taskTypesWithEvidence: (trainerAppConfig?.taskTypesWithEvidence ?? [])
        .filter((item) => item.evidenceRequired)
        .map((item) => Object.entries(TASK_TYPE_MAP).find(([, v]) => v === item.taskType)?.[0] as string),
});

export const mapTrainingProgramConfigFromVmToApi = (
    trainingProgramsConfig: VM.TrainingProgramsConfig
): API.TrainingProgramsConfig => ({
    id: trainingProgramsConfig.id,
    applicableLocationsConfig: mapApplicableLocationsConfigFromVmToApi(
        trainingProgramsConfig.applicableLocationsConfig
    ),
    trainerAppConfig: mapTrainerAppConfigFromVmToApi(trainingProgramsConfig.trainerAppConfig),
});

export const mapApplicableLocationsConfigFromVmToApi = (
    applicableLocationsConfig: VM.ApplicableLocationsConfig
): API.ApplicableLocationsConfig => ({
    enableApplicableLocations: applicableLocationsConfig.enableApplicableLocations,
});

export const mapTrainerAppConfigFromVmToApi = (trainerAppConfig: VM.TrainerAppConfig): API.TrainerAppConfig => ({
    allowActions: trainerAppConfig.allowActions,
    enableTrainerSignature: trainerAppConfig.enableTrainerSignature,
    enableOperatorSignature: trainerAppConfig.enableOperatorSignature,
    enableUploadEvidence: trainerAppConfig.enableUploadEvidence,
    taskTypesWithEvidence: Object.entries(TASK_TYPE_MAP).map(([key, taskType]) => ({
        taskType,
        evidenceRequired: trainerAppConfig.taskTypesWithEvidence.includes(key),
    })),
});
